var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFilter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "none",
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M3 5.286h1.48C4.952 3.954 6.222 3 7.715 3c1.493 0 2.763.954 3.234 2.286H17c.552 0 1 .447 1 1v.285c0 .553-.448 1-1 1h-6.052c-.47 1.332-1.74 2.286-3.234 2.286-1.493 0-2.763-.954-3.233-2.286H3c-.552 0-1-.447-1-1v-.285c0-.553.448-1 1-1zm5.857 1.143c0 .63-.512 1.142-1.143 1.142-.63 0-1.143-.511-1.143-1.142 0-.632.512-1.143 1.143-1.143s1.143.511 1.143 1.143zM2 13.143c0-.552.448-1 1-1h6.052c.47-1.332 1.74-2.286 3.234-2.286 1.492 0 2.763.954 3.233 2.286H17c.552 0 1 .448 1 1v.286c0 .552-.448 1-1 1h-1.48c-.471 1.331-1.742 2.285-3.234 2.285-1.493 0-2.763-.954-3.234-2.285H3c-.552 0-1-.448-1-1v-.286zm10.286 1.286c.63 0 1.143-.512 1.143-1.143s-.512-1.143-1.143-1.143-1.143.511-1.143 1.143c0 .63.511 1.143 1.143 1.143z",
    clipRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilter);
export default __webpack_public_path__ + "static/media/filter.32a088b1e9b074ab5b7243f83ed38dc7.svg";
export { ForwardRef as ReactComponent };